import Cookies from 'js-cookie';

export const getCookie = key => {
    let result = Cookies.get(key);
    if (result && result.length > 0) {
      return result;
    }
    return "";
};

export const removeCookie = key => {
  Cookies.remove(key);
}

export const isLogin = () => {
  let headimage = getCookie('headimage');
  let nickname = getCookie('nickname');
  let unionId = getCookie('unionId');
  if (headimage && headimage.length > 0 && nickname && nickname.length > 0 && unionId && unionId.length > 0) {
    // 已登录
    return true
  }else {
    // 未登录
    return false
  }
}
